import { api } from '../DefaultService';
import { IPaginationParams } from '../types';
import {
  ISchoolTransportationCreateParams,
  ISchoolTransportationFilterParams,
  ISchoolTransportationProps,
  ISchoolTransportationSimpleProps,
  ISchoolTransportationSummaryProps,
  ISchoolTransportationTripAttendanceProps,
  ISchoolTransportationTripProps,
  ISchoolTransportationUpdateParams,
} from './types';

const ENDPOINT = 'v1/schoolTransportation';

const formatApiError = (error: any): Error => {
  return new Error(
    error?.response?.data?.userMessage ||
      error?.response?.data?.message ||
      'Ocorreu um erro inesperado. Tente novamente.',
  );
};

export const createSchoolTransportationAsync = async ({
  data,
}: ISchoolTransportationCreateParams): Promise<ISchoolTransportationProps> => {
  try {
    const response = await api.post(ENDPOINT, data);
    return response.data;
  } catch (error) {
    throw formatApiError(error);
  }
};

export const getSchoolTransportationByIdAsync = async (
  id: number,
): Promise<ISchoolTransportationProps> => {
  try {
    const response = await api.get(`${ENDPOINT}/${id}`);
    return response.data;
  } catch (error) {
    throw formatApiError(error);
  }
};

export const getAllSchoolTransportationByLicenseAsync = async (
  pagination: IPaginationParams,
  filter: ISchoolTransportationFilterParams,
): Promise<ISchoolTransportationSimpleProps[]> => {
  try {
    const response = await api.get(`${ENDPOINT}/getAllByLicense`, {
      params: {
        ...pagination,
        name: filter?.name,
      },
    });
    return response.data;
  } catch (error) {
    throw formatApiError(error);
  }
};

export const getAllSchoolTransportationCountAsync = async (
  filter: ISchoolTransportationFilterParams,
): Promise<number> => {
  try {
    const response = await api.get(`${ENDPOINT}/getAllByLicense/count`, {
      params: {
        name: filter?.name,
      },
    });
    return response.data;
  } catch (error) {
    throw formatApiError(error);
  }
};

export const getSchoolTransportationSummaryAsync =
  async (): Promise<ISchoolTransportationSummaryProps> => {
    try {
      const response = await api.get(`${ENDPOINT}/summary`);
      return response.data;
    } catch (error) {
      throw formatApiError(error);
    }
  };

export const updateSchoolTransportationAsync = async ({
  id,
  data,
}: ISchoolTransportationUpdateParams): Promise<ISchoolTransportationProps> => {
  try {
    const response = await api.put(`${ENDPOINT}/${id}`, data);
    return response.data;
  } catch (error) {
    throw formatApiError(error);
  }
};

export const deleteSchoolTransportationAsync = async (
  id: number,
): Promise<void> => {
  try {
    const response = await api.delete(`${ENDPOINT}/${id}`);
  } catch (error) {
    throw formatApiError(error);
  }
};

export const getActiveSchoolTransportationTripAsync = async (
  transportationId: number,
): Promise<ISchoolTransportationTripProps | null> => {
  try {
    const response = await api.get(
      `${ENDPOINT}/${transportationId}/trips/active`,
    );
    return response.data;
  } catch (error: any) {
    if (error?.response?.status === 404) return null;
    throw formatApiError(error);
  }
};

export const getSchoolTransportationTripAttendanceAsync = async (
  tripId: number,
): Promise<ISchoolTransportationTripAttendanceProps> => {
  try {
    const response = await api.get(`${ENDPOINT}/trips/${tripId}/attendance`);
    return response.data;
  } catch (error) {
    throw formatApiError(error);
  }
};

export const getActiveSchoolTransportationAttendanceAsync = async (
  transportationId: number,
): Promise<ISchoolTransportationTripAttendanceProps | null> => {
  const trip = await getActiveSchoolTransportationTripAsync(transportationId);
  if (!trip) return null;
  return getSchoolTransportationTripAttendanceAsync(trip.id);
};
